<template>
	<el-container class="admin-layout">
		<!-- 侧边栏 -->
		<el-aside width="220px" class="admin-aside">
			<div class="admin-logo">
				<img v-if="logoUrl" :src="logoUrl" class="logo-img" />
				<span class="logo-text">{{ projectName }}</span>
			</div>
			<el-menu :default-active="activeMenu" router class="admin-menu" background-color="#1f2d3d"
				text-color="#bfcbd9" active-text-color="#409eff">
				<el-menu-item index="/admin/system">
					<i class="el-icon-setting"></i>
					<span slot="title">系统配置</span>
				</el-menu-item>
				<el-menu-item index="/admin/user">
					<i class="el-icon-user"></i>
					<span slot="title">用户管理</span>
				</el-menu-item>
				<el-menu-item index="/admin/group">
					<i class="el-icon-s-custom"></i>
					<span slot="title">群聊管理</span>
				</el-menu-item>
				<el-menu-item index="/admin/sensitive">
					<i class="el-icon-warning"></i>
					<span slot="title">敏感词管理</span>
				</el-menu-item>
				<el-menu-item index="/admin/realname">
					<i class="el-icon-finished"></i>
					<span slot="title">实名审核</span>
				</el-menu-item>
			<el-menu-item index="/admin/wallet">
				<i class="el-icon-coin"></i>
				<span slot="title">钱包风控</span>
			</el-menu-item>
			<!-- 外链管理已整合进"系统配置"页的外链配置标签 -->
		</el-menu>
		</el-aside>

		<!-- 主区域 -->
		<el-container>
			<el-header class="admin-header">
				<div class="header-title">{{ pageTitle }}</div>
				<div class="header-right">
					<span class="admin-name">管理员：{{ adminName }}</span>
					<el-button size="small" @click="backToIm">返回聊天</el-button>
					<el-button size="small" type="danger" plain @click="logout">退出登录</el-button>
				</div>
			</el-header>
			<el-main class="admin-main">
				<router-view></router-view>
			</el-main>
		</el-container>
	</el-container>
</template>

<script>
import { clearLoginSession } from '../../api/auth.js'

export default {
	data() {
		return {
			projectName: '比特IM',
			logoUrl: '',
			titles: {
				'/admin/system': '系统配置',
				'/admin/user': '用户管理',
				'/admin/group': '群聊管理',
				'/admin/sensitive': '敏感词管理',
				'/admin/realname': '实名审核',
				'/admin/wallet': '钱包风控'
			}
		}
	},
	computed: {
		activeMenu() {
			return this.$route.path
		},
		pageTitle() {
			return this.titles[this.$route.path] || '管理后台'
		},
		adminName() {
			let u = this.userStore.userInfo
			return u ? (u.nickName || u.userName) : ''
		}
	},
	created() {
		// 拉取系统配置用于展示项目名/Logo
		this.loadConfig()
	},
	methods: {
		loadConfig() {
			import('../../api/adminApi.js').then(({ default: AdminApi }) => {
				new AdminApi().getConfig().then((cfg) => {
					if (cfg) {
						this.projectName = cfg.projectName || '比特IM'
						this.logoUrl = cfg.logoUrl || ''
					}
				}).catch(() => {})
			})
		},
		backToIm() {
			this.$router.push('/home/chat')
		},
		logout() {
			clearLoginSession()
			this.userStore.clear()
			location.href = '/'
		}
	}
}
</script>

<style scoped>
.admin-layout {
	height: 100vh;
}

.admin-aside {
	background: #1f2d3d;
}

.admin-logo {
	height: 60px;
	display: flex;
	align-items: center;
	padding: 0 16px;
	color: #fff;
	font-size: 18px;
	font-weight: 600;
	border-bottom: 1px solid #2a3a4d;
}

.logo-img {
	width: 30px;
	height: 30px;
	border-radius: 6px;
	margin-right: 10px;
	object-fit: cover;
}

.admin-menu {
	border-right: none;
}

.admin-header {
	background: #fff;
	display: flex;
	align-items: center;
	justify-content: space-between;
	border-bottom: 1px solid #ebeef5;
	box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
}

.header-title {
	font-size: 18px;
	font-weight: 600;
	color: #303133;
}

.header-right {
	display: flex;
	align-items: center;
}

.admin-name {
	margin-right: 16px;
	color: #606266;
	font-size: 14px;
}

.admin-main {
	background: #f0f2f5;
	padding: 20px;
}
</style>
